import { IUserViewModel } from "../../../model/respone/user/IUserViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eUserActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IUserViewModel[],
    LOAD_ERRR: "",

    SHOW_EDIT_MODAL: {} as IUserViewModel| undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IUserViewModel,
    SAVE_SUCCESS: undefined,
    SAVE_ERRR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERRR: "",

};

export const eUserActionTypeIds = generateActionTypeIds(
    eUserActionsObj,
    "USER"
);
export type IUserActionTypes = IGenericActionType<
    typeof eUserActionsObj,
    "USER"
>;
